module.exports = __webpack_public_path__ + "img/jx-0001-19-2.prt.e3377d00.jpg";